import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { Title, LoadingCard } from '../../Shared';
import { AdminHeader } from '../';
import { userManagementActions } from '../../_actions';

function UserSingle(props) {
  const { getSingle } = props;
  const { userId } = props.match.params;

  useEffect(() => {
    if (userId) {
      getSingle(userId);
    }
  }, [getSingle, userId]);
  const { user, loading } = props;
  return (
    <Fragment>
      {loading && <LoadingCard />}
      {!loading && user && (
        <Fragment>
          <Title text={user.firstName + ' ' + user.lastName} />
          <AdminHeader goBack title={user.firstName + ' ' + user.lastName} />
          <Container className="mt-4">
            <Row>
              <Col>
                <h3>{user.displayName}</h3>
                <p>
                  <strong>Phone:</strong> <a href={`tel:${user.phoneNumber}`}>{user.phoneNumber}</a>
                </p>
                <p>
                  <strong>Email:</strong> <a href={`mailto:${user.email}`}>{user.email}</a>
                </p>
                <p>
                  <strong>Role:</strong> {user.roles[0] || 'Regular user'}
                </p>
                <p>
                  <strong>Date Of Birth:</strong> {user.dateOfBirth || 'Not specified'}
                </p>
                <p>
                  <strong>Email notifications: </strong> {user.emailNotifications ? 'Yes' : 'No'}
                </p>
                <p>
                  <strong>SMS notifications: </strong> {user.smsNotifications ? 'Yes' : 'No'}
                </p>
              </Col>
            </Row>
          </Container>
        </Fragment>
      )}
    </Fragment>
  );
}

function mapStateToProps(state) {
  const { user = null, loading = true } = state.userManagement;
  return { user, loading };
}

const mapDispatchToProps = {
  getSingle: userManagementActions.getSingle
};

const connectedUserSingle = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSingle);
export { connectedUserSingle as UserSingle };
